import { styled } from "@mui/material/styles";
import { COLORS } from "../../constants/colors";

export const UserName = styled("div")`
  color: ${COLORS.TEXT_PRIMARY};
  font-family: Roboto;
  font-size: 14px;
  max-width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
`;
